// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-8868d91c]{padding:4px}table[data-v-8868d91c]{border-collapse:collapse}table[data-v-8868d91c],td[data-v-8868d91c],th[data-v-8868d91c]{border:.5px solid #000}thead[data-v-8868d91c]{display:table-row-group}tr td[data-v-8868d91c]{page-break-inside:avoid}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
